<div class="ui-g">
  <div class="ui-g-12">
    <div class="card px-0">
      <div class="px-3">
        <div class="d-flex">
          <div class="flex-grow-1">
            <h2 (click)="expanded = !expanded" class="mt-2 mb-2">Booking Summary</h2>
          </div>
          <div class="flex-shrink-1">
            <i
              [class]="
                expanded
                  ? 'fa-2x fa fa-chevron-up link-style'
                  : 'fa-2x fa fa-chevron-down link-style'
              "
              (click)="expanded = !expanded"
            ></i>
          </div>
        </div>
      </div>

      <div *ngIf="expanded" style="border-top: 1px solid #ddd" class="mt-2">
        <div class="px-3">
          <form [formGroup]="searchForm">
            <div class="search-users"><i class="fa fa-search"></i> Search Users</div>
            <div class="d-flex flex-wrap" style="grid-gap: 20px">
              <div class="flex-grow-1">
                <div>
                  <input class="input-field" formControlName="firstName" placeholder="First Name" />
                </div>
              </div>
              <div class="flex-grow-1">
                <div>
                  <input class="input-field" formControlName="lastName" placeholder="Last Name" />
                </div>
              </div>
              <div class="flex-grow-1">
                <div>
                  <input class="input-field" formControlName="email" placeholder="E-mail" />
                </div>
              </div>
              <div class="flex-shrink-1 no-wrap">
                <button
                  pButton
                  type="button"
                  class="ui-button alternate-btn"
                  label="Clear"
                  (click)="clear()"
                ></button>
              </div>
            </div>
          </form>

          <div class="inner-widget">
            <div class="widget-header">
              <div class="select-users">Select Users</div>
              <div class="select-summary">
                Select a summary option to provide selected users with email notifications of an
                overview of previous movements.
              </div>
            </div>
            <div>
              <div *ngIf="loading" class="text-center p-4">
                <i class="fa fa-2x fa-spin fa-spinner"></i> Loading Users
              </div>

              <p-table
                [paginator]="true"
                [rowsPerPageOptions]="[10, 20, 30]"
                [rows]="10"
                *ngIf="!loading"
                [value]="filteredUsers()"
              >
                <ng-template pTemplate="header">
                  <tr class="user-table">
                    <th style="width: 50px; text-align: center">&nbsp;</th>
                    <th>Name</th>
                    <th>E-mail</th>
                    <th style="width: 100px; text-align: center">Daily Summary</th>
                    <th style="width: 100px; text-align: center">Weekly Summary</th>
                    <th style="width: 100px; text-align: center">Monthly Summary</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                  <tr class="user-table">
                    <td style="text-align: center"><i class="fa fa-user-o"></i></td>
                    <td>
                      <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                    </td>
                    <td
                      style="overflow-x: hidden; text-overflow: ellipsis"
                      title="{{ item.email }}"
                    >
                      {{ item.email }}
                    </td>
                    <td style="text-align: center">
                      <p-checkbox
                        binary="true"
                        [(ngModel)]="item.receiveDailySummary"
                        (ngModelChange)="updateSetting(item, 'Daily', item.receiveDailySummary)"
                      ></p-checkbox>
                    </td>
                    <td style="text-align: center">
                      <p-checkbox
                        binary="true"
                        [(ngModel)]="item.receiveWeeklySummary"
                        (ngModelChange)="updateSetting(item, 'Weekly', item.receiveWeeklySummary)"
                      ></p-checkbox>
                    </td>
                    <td style="text-align: center">
                      <p-checkbox
                        binary="true"
                        [(ngModel)]="item.receiveMonthlySummary"
                        (ngModelChange)="updateSetting(item, 'Monthly', item.receiveMonthlySummary)"
                      ></p-checkbox>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="px-3">
          <div class="p-2">
            <div style="font-size: 20px; font-weight: bold">Customer Logo</div>
            <div style="font-size: 13px">(100px x 27px)</div>
          </div>

          <div class="d-flex flex-wrap">
            <div class="flex-shrink-1">
              <p-fileUpload
                name="files"
                multiple="false"
                url="/api/filestorage/fileuploading"
                withCredentials="true"
                [maxFileSize]="83886080"
                (onBeforeUpload)="onBeforeUpload($event)"
                (onSelect)="onSelect($event)"
                (onUpload)="onFileUpload($event)"
                [accept]="'image/*'"
                [disabled]="uploading"
                auto="true"
                chooseLabel="Upload Logo"
                mode="basic"
              >
              </p-fileUpload>
              <span *ngIf="uploading">
                &nbsp; <i class="fa fa-spin fa-spinner"></i> Uploading..</span
              >
            </div>
            <div class="flex-grow-1">
              <div
                *ngIf="logoSetting != null && logoSetting.charValue != ''"
                style="padding-top: 2px"
              >
                &nbsp; <img src="{{ presignedURL }}" style="width: 100px; height: 27px" /> &nbsp;
                <i
                  class="fa fa-15x fa-trash-o"
                  (click)="removeLogo()"
                  style="vertical-align: top"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
